import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  updateContent: '',
  expertGroupContent: false,
  headerHidden: false,
};

const tabSlice = createSlice({
  name: 'contentSideBar',
  initialState,
  reducers: {
    setUpdateContent: (state, action) => {
      state.updateContent = action.payload.updateContent;
    },
    setExpertGroupContent: (state, action) => {
      state.expertGroupContent = action.payload.expertGroupContent;
    },
    setHeaderHidden: (state, action) => {
      state.headerHidden = action.payload;
    },
  },
});

export const { setUpdateContent, setExpertGroupContent, setHeaderHidden } = tabSlice.actions;
export const updateContent = state => state.contentSideBar.updateContent;
export const expertGroupContent = state => state.contentSideBar.expertGroupContent;
export const headerHidden = state => state.contentSideBar.headerHidden;
export default tabSlice.reducer;